<template>
  <transition-group v-bind="$attrs" @before-enter="setup" @leave="hideItems">
    <slot />
  </transition-group>
</template>

<script>
// Utilities
import { timeToCSS } from 'Utils'

export default {
  name: 'TransitionGroupEllipsis',

  props: {
    time: {
      type: Number,
      default: 0,
    },
    direction: {
      type: String,
      default: 'left',
    },
    separation: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    formattedTime() {
      return timeToCSS(this.time)
    },
  },
  methods: {
    getDirection() {
      let goTo = ''
      switch (this.direction) {
        case 'top':
          goTo = 'bottom'
          break
        case 'bottom':
          goTo = 'top'
          break
        case 'left':
          goTo = 'right'
          break
        case 'right':
          goTo = 'left'
          break
      }
      return goTo
    },
    prepareChildElements(element) {
      element.style.position = 'absolute'
      element.style[this.getDirection()] = '0px'
      element.style.transition = `${this.formattedTime}s ${this.getDirection()} ease`
    },
    moveChildElements(elements) {
      elements.forEach((element) => {
        // calculating position and separation
        const elementWidth = element.offsetWidth + this.separation
        const elementPosition = elementWidth * elements.indexOf(element)
        element.style[this.getDirection()] = `${elementPosition}px`
      })
    },
    calculateContainerSize(childrens) {
      const paddingDirection = `padding-${this.getDirection()}`
      const containerHeight = childrens[0]?.offsetHeight
      const containerWidth = childrens[0]?.offsetWidth
      const paddingSize = childrens[0]?.offsetHeight * childrens.length

      return { paddingDirection, containerHeight, containerWidth, paddingSize }
    },
    resetContainerSize(childNodes) {
      const container = this.$el
      const { containerHeight, containerWidth } = this.calculateContainerSize(childNodes)
      container.style.padding = `0px`
      container.style.height = `${containerHeight}px`
      container.style.width = `${containerWidth}px`
    },
    async setup() {
      await this.$nextTick()
      const container = this.$el
      const childNodes = [...container.children]
      const { paddingSize, containerWidth, containerHeight, paddingDirection } =
        this.calculateContainerSize(childNodes)
      // container.style.position = 'absolute'
      if (this.direction !== 'top') container.style.top = '0'
      // top, bottom, right or left
      container.style[this.getDirection()] = '0'
      container.style.width = `${containerWidth}px`
      container.style.height = `${containerHeight}px`
      container.style[paddingDirection] = `${paddingSize}px`
      childNodes.forEach((child) => this.prepareChildElements(child))
      this.moveChildElements(childNodes)
    },
    async hideItems() {
      const container = this.$el
      const childNodes = [...container.children]
      childNodes.forEach((child) => (child.style[this.getDirection()] = '0px'))
      this.resetContainerSize(childNodes)
    },
  },
  mounted() {
    if (this.$el && this.$el.nodeName === '#comment') return
    this.setup()
  },
}
</script>

<style scoped></style>
